import * as React from 'react'

import Tooltip from '../ToolTip'
const TableTitileActionButtons = ({
  actions,
}: {
  actions: {
    icon: string
    onClick: () => void
    tooltip: string
    alt: string
    primary?: boolean
  }[]
}) => {
  return (
    <>
      {actions.map((action, i) => (
        <Tooltip key={action.tooltip ?? i} text={action?.tooltip}>
          <div
            className={`tw-cursor-pointer tw-rounded-lg tw-p-2 ${action?.primary ? "tw-bg-primary" : "tw-bg-secondary"} `}
            onClick={action?.onClick}
          >
            <img src={action.icon} alt={action?.alt} />
          </div>
        </Tooltip>
      ))}
    </>
  )
}

export default TableTitileActionButtons
